export default __webpack_public_path__ + "static/media/img-27.fe69c1c7.jpg";